import React from "react";
import Step1 from "components/organisms/AddDrugsSteps/Step1";
import Step2 from "components/organisms/AddDrugsSteps/Step2";
import Step3 from "components/organisms/AddDrugsSteps/Step3";
import Step4 from "components/organisms/AddDrugsSteps/Step4";
import PharmacyStep from "components/organisms/AddDrugsSteps/PharmacyStep";

export const pharmacyTypesMap = {
  Retail: "retail",
  "Mail Order": "mailOrder",
  "Preferred Retail": "preferredRetail",
  "Standard Retail": "retail",
  "Preferred Mail Order": "preferredMailOrder",
  "Standard Mail Order": "mailOrder",
};

const pharmacySteps = {
  retail: {
    title: "Retail",
    content: <PharmacyStep key="retail" title="Retail" type="retail" />,
  },
  mailOrder: {
    title: "Mail Order",
    content: <PharmacyStep key="mailOrder" title="Mail Order" type="mailOrder" />,
  },
  preferredRetail: {
    title: "Preferred Retail",
    content: <PharmacyStep key="preferredRetail" title="Preferred Retail" type="preferredRetail" />,
  },
  standardRetail: {
    title: "Standard Retail",
    content: <PharmacyStep key="standardRetail" title="Standard Retail" type="retail" />,
  },
  preferredMailOrder: {
    title: "Preferred Mail Order",
    content: <PharmacyStep key="preferredMailOrder" title="Preferred Mail Order" type="preferredMailOrder" />,
  },
  standardMailOrder: {
    title: "Standard Mail Order",
    content: <PharmacyStep key="standardMailOrder" title="Standard Mail Order" type="mailOrder" />,
  },
};

export const drugsSteps = (typesOfPharmacies) => {
  const baseSteps = [
    {
      title: "Pharmacy Benefit Managers",
      content: <Step1 />,
    },
    {
      title: "Tiers",
      content: <Step2 />,
    },
    {
      title: "Drugs",
      content: <Step3 />,
    },
    {
      title: "Deductibles and OOPs",
      content: <Step4 />,
    },
  ];

  switch (typesOfPharmacies) {
    case 1:
      return [...baseSteps, pharmacySteps.retail];
    case 2:
      return [...baseSteps, pharmacySteps.retail, pharmacySteps.mailOrder];
    case 4:
      return [
        ...baseSteps,
        pharmacySteps.preferredRetail,
        pharmacySteps.standardRetail,
        pharmacySteps.preferredMailOrder,
        pharmacySteps.standardMailOrder,
      ];
    default:
      return baseSteps;
  }
};
